import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step5 } from '../../../../../shared/models/component-messages/mapaAT/step5';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { Attribution } from '../../models/Attribution';
import { LotMarche } from '../../models/LotMarche';
import { CTRL_322 } from '../../../../validators/322/ctrl322';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';
import { AttributionService } from '../../services/attribution/attribution.service';

@Component({
  selector: 'app-step5',
  templateUrl: './step5.component.html'
})
export class Step5Component implements OnInit {

  @Input() attribution: Attribution;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;
  public rg4 = CTRL_322.id + '_1';

  public step5 = new Step5();
  // Pulse technique : false puis true force la reconstruction des fieldsets de lots (cf. removelotMarche()).
  public areLotsRendered = true;

  constructor(private formExtractorService: FormExtractorService, public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private avisDataTransferService: AvisDataTransferService, private cd: ChangeDetectorRef,
    private attributionService: AttributionService) { }

  ngOnInit(): void {
    if (!this.attribution.lotMarche) {
      this.attribution.lotMarche = []; 
    }
  }

  getUid() {
    return this.uid + '_SepSep_AttributionFromMAPA_SepSep_Attribution';
  }

  addlotMarche() {
		this.attribution.lotMarche.push(new LotMarche());
  }

  removelotMarche(i: number) {
		// Resynchronise le modèle avec les valeurs actuellement saisies dans le formulaire AVANT de
		// retirer le lot, sinon les lots restants perdent leurs valeurs saisies à la reconstruction ci-dessous.
		const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(this.parentForm);
		this.attribution = this.attributionService.getAttribution(controls, this.formExtractorService, 6); // 6 = step "Attribution des lots"

		this.attribution.lotMarche.splice(i, 1);

		// Force la destruction/reconstruction des fieldsets : sinon Angular réutilise les FormControl
		// existants dont le nom (indexé par position) ne correspond plus après suppression.
		this.areLotsRendered = false;
		this.cd.detectChanges();
		this.areLotsRendered = true;
	}

  public getType() {
    return this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.attributionFromMAPA.resultatAttribution;
  }

  public isAttribue(): boolean {
    return this.getType() !== RadioCheckBoxEnum.sansSuite
      && this.getType() !== RadioCheckBoxEnum.infructueux;
  }

  public isAttributionParLots(): boolean {
    if (this.getType() === RadioCheckBoxEnum.attribueLots
    || this.getType() === RadioCheckBoxEnum.lotsInfructueux) {
      this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ }));
      let lotMarcheIter = 1;
    }
    return this.getType() === RadioCheckBoxEnum.attribueLots
      || this.getType() === RadioCheckBoxEnum.lotsInfructueux;
  }

  getStepId() {
	  return this.uid + '_';
	}
}
